import React from 'react';

import { HtmlSafe } from 'polaris-coreweb/exports';

import { Text } from 'Components/atoms/Text';

export const getSiteLegalDisclaimer = (contributors) => {
  if (contributors && Array.isArray(contributors) && contributors.length && contributors[0].generalLegalDisclaimer) {
    return (
      <div className="-site-legal">
        <Text span={false}>
          <HtmlSafe html={contributors[0].generalLegalDisclaimer || ''} />
        </Text>
      </div>
    );
  }

  return null;
};
